import { Deal } from "../../types/deal";
import { SeriesByYear, YearKey } from "./factors";

function yearsFor(deal: any): YearKey[] {
  return [
    "y0",
    "y1",
    "y2",
    "y3",
    "y4",
    "y5",
    "y6",
    "y7",
    "y8",
    "y9",
    "y10",
  ] as YearKey[];
}

/**
 * (0% в Y0, X% в Y1-Y10)
 */
function expandRate(rate: number, years: YearKey[]): SeriesByYear {
  const out: Partial<SeriesByYear> = {};
  years.forEach((y, i) => (out[y] = i === 0 ? 0 : rate));
  return out as SeriesByYear;
}

/**
 * (1x в Y0, Xx в Y1-Y10)
 */
function expandMult(mult: number, years: YearKey[]): SeriesByYear {
  const out: Partial<SeriesByYear> = {};
  years.forEach((y, i) => (out[y] = i === 0 ? 1 : mult));
  return out as SeriesByYear;
}

export function selectToplineGrowthRateByYear(deal: Deal): SeriesByYear {
  const years = yearsFor(deal);
  const rampKpis = deal?.kpis?.ramp;

  const flatY2 = (rampKpis?.revenueGrowthY2 || 3) / 100;
  // (2% по умолчанию, если не найдено)
  const flatY3Plus = (rampKpis?.revenueGrowthY3Plus || 2) / 100;

  const out: Partial<SeriesByYear> = {};
  years.forEach((y) => {
    const yearNum = Number(y.slice(1));
    if (yearNum === 0) out[y] = 0;
    else if (yearNum === 1)
      out[y] = 0; // Y1 не имеет роста относительно Y1
    else if (yearNum === 2) out[y] = flatY2;
    else out[y] = flatY3Plus;
  });
  return out as SeriesByYear;
}

export function selectInflationRateByYear(deal: Deal): SeriesByYear {
  const years = yearsFor(deal);
  const flatRate = (deal?.kpis?.ramp?.inflationRate || 2) / 100;
  return expandRate(flatRate, years);
}

export function selectToplineRampByYear(deal: Deal): SeriesByYear {
  const years = yearsFor(deal);

  return expandMult(1.0, years);
}

export function selectCostRampByYear(deal: Deal): SeriesByYear {
  const years = yearsFor(deal);
  return expandMult(1.0, years);
}

export function selectExitYearIndex(deal: Deal): number {
  return deal?.kpis?.exit?.holdPeriodYears || 10;
}
